import { render, staticRenderFns } from "./KycInstitutionalList.vue?vue&type=template&id=76f8eb00"
import script from "./KycInstitutionalList.vue?vue&type=script&lang=js"
export * from "./KycInstitutionalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports